import * as React from 'react';
import { AppBar, Box, Button, Container, Toolbar } from '@mui/material';
import blueLogo from 'assets/images/companyLogo.svg';
import { getBranding } from 'config/tenantConfig';

function FAQHeader() {
  return (
    <AppBar position="static" className="bgColorBlue boxShadowNone">
      <Container maxWidth="xl" className="h100 faqMobileRes">
        <Toolbar disableGutters>
          <img src={getBranding().logo || blueLogo} alt="blueLogo" className="logoImage" />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default FAQHeader;
